export const proposalMemo = (proposal = {}) =>
  [...new Set([proposal?.location_text, proposal?.machine_text].map(value => String(value || "").trim()).filter(Boolean))].join("\n");
